<script>
    import {getGPTransFunc} from "./gp-translations.js";
    let trans = getGPTransFunc("gp-upgrade");
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

    export let activationFromWebsiteAvailable;
</script>

<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title">{@html trans("Premium feature")}</h4>
</div>
<div class="modal-body">
    <div class="premiumDescription">
        <h2>{@html trans("Your photo in&nbsp;the&nbsp;background")}...</h2>
        <p>...{@html trans("awaits you in the full version of the app")}. {@html trans("Plus over 1.500 plants, additional textures and 4&nbsp;season views!")}</p>
        <img src="img/upgradeCustomBG.jpg"/>
        <p class="strong">{@html trans("Access everywhere<br/>Web app | Mac/Win app | iOS app")}</p>
    </div>
    <div class="onlyInPackage">
        <p>{@html trans("This feature is available only in the full version of GardenPuzzle")}.</p>
        <button type="button" class="btn btn-premium" on:click={()=>dispatch('upgrade')}>{trans("Upgrade now!")}</button>
    </div>
    {#if activationFromWebsiteAvailable}<div class="activateLink">{@html trans("If you already purchased access on our website")} <a on:click={()=>dispatch('activate')}>{@html trans("click here to unlock all features")}.</a></div>{/if}
</div>